import { render, staticRenderFns } from "./TextEditForm.vue?vue&type=template&id=36b32fd3"
import script from "./TextEditForm.vue?vue&type=script&lang=js"
export * from "./TextEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports